import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { IMultipleIdsParams } from '../../../spacesPlatform/utils/actionParams';
import { SubscriptionDataConditionType } from '../types/SubscriptionDataCondition';

export interface ISetSubscriptionsDataConditionParams extends IMultipleIdsParams {
  dataConditionType: SubscriptionDataConditionType;
}

export class SetSubscriptionsDataConditionRequest extends Request<ISetSubscriptionsDataConditionParams, IEmptyResult> {
  constructor(params: ISetSubscriptionsDataConditionParams) {
    super('setSubscriptionsDataCondition', params);
  }
}
